import { render } from "./StoresRegisterCustomFieldsForm.vue?vue&type=template&id=5e0414d4&scoped=true"
import script from "./StoresRegisterCustomFieldsForm.vue?vue&type=script&lang=js"
export * from "./StoresRegisterCustomFieldsForm.vue?vue&type=script&lang=js"

import "./StoresRegisterCustomFieldsForm.vue?vue&type=style&index=0&id=5e0414d4&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0414d4"]])

export default __exports__